// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"ff26062a","453":"48b2801f","503":"bc6be695","706":"66984d7c","745":"cbdb8022"}[chunkId] + ".chunk.js";
};